module.exports = __webpack_public_path__ + "static/media/ms_teams_icon.ab53e7e1.svg";